import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function InboxPage({ onOpenRun }) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  async function load() {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
    } catch (e) {
      setErr("Could not load inbox.");
    }
  }

  async function markRead(id) {
    await api.post(`/notifications/${id}/read`).catch(() => {});
    setItems((arr) => arr.map((n) => (n.id === id ? { ...n, read: true } : n)));
  }

  async function del(id, e) {
    e.stopPropagation();
    await api.delete(`/notifications/${id}`).catch(() => {});
    setItems((arr) => arr.filter((n) => n.id !== id));
  }

  return (
    <div className="grain blueprint-grid min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
        <div className="mb-8">
          <div className="label-xs">Inbox</div>
          <h1 className="font-serif-display text-5xl tracking-tighter">Communication.</h1>
          <p className="text-[15px] text-[#A8B3C7] mt-2 max-w-xl">
            Status updates from the Communication agent. Delivered straight here when
            email is not configured.
          </p>
        </div>

        {err && <div className="font-mono text-sm text-[#FF5B5B]">{err}</div>}

        <div className="border-t border-l hairline">
          {items === null && (
            <div className="p-8 font-mono text-sm">Loading…</div>
          )}
          {items && items.length === 0 && (
            <div className="p-8 font-mono text-sm text-[#A8B3C7]" data-testid="inbox-empty">
              No messages. The Communication agent will drop run summaries here.
            </div>
          )}
          {items && items.map((n) => (
            <article
              key={n.id}
              className={"grid grid-cols-12 border-r border-b hairline " + (n.read ? "bg-transparent" : "bg-[#00B4E608]")}
              data-testid={`inbox-row-${n.id}`}
            >
              <div className="col-span-12 md:col-span-9 p-6">
                <div className="flex items-center gap-3 mb-2">
                  {!n.read && <span className="dot working" data-testid="inbox-unread-dot" />}
                  <div className="label-xs">{new Date(n.created_at).toLocaleString()}</div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#A8B3C7]">
                    via in-app inbox
                  </span>
                </div>
                <div className="font-serif-display text-2xl italic leading-tight mb-3">"{n.goal}"</div>
                <p className="text-[14.5px] leading-[1.7] text-[#E4EAF4] whitespace-pre-wrap">{n.body}</p>
              </div>
              <div className="col-span-12 md:col-span-3 border-l hairline p-6 flex flex-col gap-3 justify-between">
                <div className="space-y-3">
                  <button
                    onClick={() => onOpenRun(n.run_id)}
                    className="font-mono text-[11px] uppercase tracking-[0.2em] underline underline-offset-4 hover:text-[#00B4E6] block text-left"
                    data-testid={`inbox-open-run-${n.id}`}
                  >
                    Open run →
                  </button>
                  {!n.read && (
                    <button
                      onClick={() => markRead(n.id)}
                      className="font-mono text-[11px] uppercase tracking-[0.2em] underline underline-offset-4 hover:text-[#00B4E6] block text-left"
                      data-testid={`inbox-mark-read-${n.id}`}
                    >
                      Mark read
                    </button>
                  )}
                </div>
                <button
                  onClick={(e) => del(n.id, e)}
                  className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF5B5B] hover:underline text-left"
                  data-testid={`inbox-delete-${n.id}`}
                >
                  Delete
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
